<nav
  class="flex h-11 shrink-0 items-center border-b border-[var(--app-border)] bg-surface-0 px-3"
  aria-label="User actions"
>
  <div class="flex items-center gap-0.5">
    <p-button
      label="My account"
      icon="pi pi-user"
      [text]="true"
      severity="secondary"
      styleClass="!gap-2 !px-2.5 !py-1 !text-xs !font-semibold !uppercase"
      (onClick)="openMyAccount()"
    />
    <p-button
      label="Logout"
      icon="pi pi-sign-out"
      [text]="true"
      severity="secondary"
      styleClass="!gap-2 !px-2.5 !py-1 !text-xs !font-semibold !uppercase"
      (onClick)="logout()"
    />
  </div>
</nav>
